import { Injectable } from '@angular/core';
import { StorageBase } from '../bases/storage-base';

/**
 * Localstorage service
 *
 * @export
 * @class LocalStorageService
 * @extends {StorageBase}
 */
@Injectable({
  providedIn: 'root'
})
export class LocalStorageService extends StorageBase {

  constructor() {
    super(localStorage);
  }
}
